import { render, staticRenderFns } from "./SalaryManage.vue?vue&type=template&id=5c669f84&scoped=true&"
import script from "./SalaryManage.vue?vue&type=script&lang=js&"
export * from "./SalaryManage.vue?vue&type=script&lang=js&"
import style0 from "./SalaryManage.vue?vue&type=style&index=0&id=5c669f84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c669f84",
  null
  
)

export default component.exports